import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Rocket } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

interface DemoExitModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DemoExitModal({ open, onOpenChange }: DemoExitModalProps) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { signOut } = useAuth();

  // Self-serve subscribe was retired March 2026 (the /subscribe tree erased in
  // 1611764fe), so conversion is sales-led — same funnel that captures the lead
  // starting the demo.
  const handleContact = async () => {
    onOpenChange(false);
    await signOut();
    navigate("/request-service");
  };

  const handleDismiss = async () => {
    onOpenChange(false);
    await signOut();
    navigate("/self-management");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader className="items-center text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Rocket className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl">
            {t("خطوتك الأخيرة قبل الانطلاق", "Your Last Step Before Launch")}
          </DialogTitle>
          <DialogDescription className="text-base leading-relaxed pt-2">
            {t(
              "تواصل مع فريقنا ليصمّم لك الباقة المناسبة لعدد وحداتك ويفعّل حسابك.",
              "Talk to our team and we'll size the right package for your units and activate your account."
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 mt-4">
          <Button onClick={handleContact} size="lg" className="w-full">
            {t("تحدث مع فريق المبيعات", "Talk to Sales")}
          </Button>
          <Button
            variant="ghost"
            onClick={handleDismiss}
            className="w-full text-muted-foreground hover:text-foreground"
          >
            {t("غير مهتم حالياً، شكراً", "Not interested for now, thank you")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
